import React, { Component } from "react";

class CouponCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      coupon: {
        id: props.coupon.couponId,
        couponName: props.coupon.couponName,
        minOrder: props.coupon.minOrder,
        maxDiscount: props.coupon.maxDiscount,
        discountPercentage: props.coupon.discountPercentage,
        reusable: props.coupon.reusable,
        expiryDate: props.coupon.expiryDate,
      },
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    let { name, value } = e.target;
    let coupon = { ...this.state.coupon };
    coupon[name] = value;
    this.setState({
      coupon: coupon,
    });
  }

  render() {
    let props = this.state.coupon;
    return (
      <React.Fragment>
        <div className="col-sm-4 mt-2">
          <div
            className="card"
            style={{ border: "2px solid rgba(0,0,0,.125)" }}
          >
            <div className="card-body">
              <h5 className="card-title">Code: {props.couponName}</h5>
              <p className="card-text">Min order: ₹ {props.minOrder}</p>
              <p className="card-text">Max discount: ₹ {props.maxDiscount}</p>
              <p className="card-text">
                Discount: {props.discountPercentage} %
              </p>
              <p className="card-text">Reusable: {props.reusable.toString()}</p>
              <p className="card-text">Expiry Date: {props.expiryDate}</p>

              <button
                href="#"
                className="btn btn-primary m-0 p-0 px-2 mr-2"
                data-toggle="modal"
                data-target={`#cpe${this.props.id}`}
                // onClick={() => this.props.setCouponId(props.id)}
              >
                Edit
              </button>
              {/* ------------------------------------ Edit Coupon Modal starts ------------------------------------*/}
              <div
                className="modal fade bd-example-modal-lg"
                id={`cpe${this.props.id}`}
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-lg" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Edit and Save the details
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <form
                        onSubmit={(e) =>
                          this.props.handleEditSubmit(e, this.state.coupon)
                        }
                      >
                        <div className="row">
                          <div className="col-md-6 m-1">
                            <div className="input-group mb-2">
                              <div className="input-group-prepend">
                                <div className="input-group-text">
                                  Coupon Code
                                </div>
                              </div>
                              <input
                                name="couponName"
                                id="couponName"
                                type="text"
                                className="form-control"
                                placeholder="Enter Coupon Name"
                                onChange={this.handleChange}
                                value={props.couponName}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-4 m-1">
                            <div className="input-group mb-2">
                              <div className="input-group-prepend">
                                <div className="input-group-text">
                                  Min order ₹
                                </div>
                              </div>
                              <input
                                name="minOrder"
                                type="number"
                                className="form-control"
                                placeholder="Min Order"
                                onChange={this.handleChange}
                                value={parseInt(props.minOrder)}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-4 m-1">
                            <div className="input-group mb-2">
                              <div className="input-group-prepend">
                                <div className="input-group-text">
                                  Max discount ₹
                                </div>
                              </div>
                              <input
                                name="maxDiscount"
                                type="number"
                                className="form-control"
                                placeholder="Max discount"
                                onChange={this.handleChange}
                                value={parseInt(props.maxDiscount)}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-3 m-1">
                            <div className="input-group mb-2">
                              <div className="input-group-prepend">
                                <div className="input-group-text">
                                  Discount %
                                </div>
                              </div>
                              <input
                                name="discountPercentage"
                                type="number"
                                className="form-control"
                                placeholder="% discount"
                                onChange={this.handleChange}
                                value={parseInt(props.discountPercentage)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <legend className="col-form-label col-md-2 mt-3">
                            Reusable:
                          </legend>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="reusable"
                              id="inlineRadio1"
                              onChange={this.handleChange}
                              value={true}
                              checked={
                                props.reusable == true ||
                                props.reusable == "true"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="inlineRadio1"
                            >
                              Yes
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="reusable"
                              onChange={this.handleChange}
                              id="inlineRadio2"
                              value={false}
                              checked={
                                props.reusable == false ||
                                props.reusable == "false"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="inlineRadio2"
                            >
                              No
                            </label>
                          </div>

                          <div className="col-md-3 m-3">
                            <label htmlFor="expiryDate" className="mt-1">
                              Expiry Date:{" "}
                            </label>
                            <input
                              type="date"
                              className="form-check-input ml-3"
                              id="expiryDate"
                              name="expiryDate"
                              onChange={this.handleChange}
                              value={props.expiryDate}
                              required
                            />
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            id={props.couponId}
                            disabled={this.props.couponBtnLoading}
                          >
                            {this.props.couponBtnLoading ? "Saving" : "Save"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {/* ------------------------------------ Edit Charge Modal ends ------------------------------------*/}
              {/* {props.isAdmin ? ( */}
              <button
                href="#"
                className="btn btn-secondary m-0 p-0 px-2"
                data-toggle="modal"
                data-target={`#cpd${this.props.id}`}
              >
                Delete
              </button>
              {/* ) : null} */}

              {/* ------------------------------------ Delete Coupon Modal starts ------------------------------------*/}
              <div
                className="modal fade"
                id={`cpd${this.props.id}`}
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Irreversible Operation
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>Are you sure you want to delete {props.couponName}</p>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={(e) =>
                          this.props.handleDeleteCoupon(e, props.id)
                        }
                        disabled={this.props.deleteBtnLoading}
                      >
                        {this.props.deleteBtnLoading ? "Deleting" : "Delete"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* ------------------------------------ Delete Coupon Modal ends ------------------------------------*/}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default CouponCard;
